import { EnvironmentModel, ProjectName } from "./environment-model.interface";

export const environment: EnvironmentModel = {
  production: false,
  apiUrl: 'https://testapi.dressmy.app',
  url: 'https://testadmin.dressmy.app',
  crossTestProdSiblingUrl: 'https://admin.dressmy.app',
  name: ProjectName.dressmy,
  heliosUrl: 'https://heliostest.dressmy.app/'
};